const localeEs = {
  // Error view
  UDE_CAREERS_ERROR: 'Ocurrió un error al obtener tus carreras',
  // Career card
  UDE_CAREER_COMPLETED: 'Carrera completada',
};
export default localeEs;
